import Skeleton, { SkeletonProps } from '@ingka/skeleton';
import React from 'react';

export default (props: SkeletonProps) => (
    <Skeleton prefix="list-ingka-" {...props} />
);
